import { createVNode as _createVNode, toDisplayString as _toDisplayString, resolveComponent as _resolveComponent, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, withScopeId as _withScopeId, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
import _imports_0 from '@/app/ui/assets/svg/ics_o_trash.svg'

const _withId = /*#__PURE__*/_withScopeId("data-v-c21cfcea")

_pushScopeId("data-v-c21cfcea")
const _hoisted_1 = { class: "m-6 h-full" }
const _hoisted_2 = { class: "flex items-center justify-between mb-3.5" }
const _hoisted_3 = /*#__PURE__*/_createVNode("div", null, [
  /*#__PURE__*/_createVNode("h3", { class: "mb-2 font-semibold text-gray-lp-300 text-base" }, " Daftar Wilayah dan Kurir Dedicated "),
  /*#__PURE__*/_createVNode("p", { class: "text-sm text-gray-lp-600" }, " Atur wilayah Anda dan pilih kurir dedicated untuk mendukung kebutuhan POS Anda. ")
], -1)
const _hoisted_4 = { class: "flex items-center gap-3.5" }
const _hoisted_5 = { class: "bg-yellow-lp-400 py-2 px-4 rounded-md space-x-2" }
const _hoisted_6 = { class: "text-yellow-lp-100" }
const _hoisted_7 = /*#__PURE__*/_createVNode("span", { class: "text-gray-lp-300" }, "kelurahan", -1)
const _hoisted_8 = { class: "w-full" }
const _hoisted_9 = { class: "flex items-center gap-4" }
const _hoisted_10 = { class: "w-full flex flex-row items-start gap-4" }
const _hoisted_11 = { class: "w-1/3" }
const _hoisted_12 = { class: "w-full" }
const _hoisted_13 = { class: "w-2/5" }
const _hoisted_14 = { class: "self-end" }
const _hoisted_15 = /*#__PURE__*/_createVNode("img", {
  src: _imports_0,
  class: "w-6 h-6"
}, null, -1)
_popScopeId()

export const render = /*#__PURE__*/_withId((_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) => {
  const _component_LpButton = _resolveComponent("LpButton")!
  const _component_AreaNameInput = _resolveComponent("AreaNameInput")!
  const _component_GeoAddressTreeSelector = _resolveComponent("GeoAddressTreeSelector")!
  const _component_AssignCourier = _resolveComponent("AssignCourier")!
  const _component_DynamicShift = _resolveComponent("DynamicShift")!

  return (_openBlock(), _createBlock("section", _hoisted_1, [
    _createVNode("div", _hoisted_2, [
      _hoisted_3,
      _createVNode("div", _hoisted_4, [
        _createVNode("div", _hoisted_5, [
          _createVNode("b", _hoisted_6, _toDisplayString(_ctx.totalAssignedVillages) + "/" + _toDisplayString(_ctx.totalAvailableVillages), 1),
          _hoisted_7
        ]),
        _createVNode(_component_LpButton, {
          outline: "",
          title: "Tambah",
          textColor: "red-lp-100",
          iconLeft: _ctx.isDisabledAddForm ? 'ics_o_plus_gray' : 'ics_o_plus',
          iconColor: _ctx.isDisabledAddForm ? 'gray-lp-600' : 'red-lp-100',
          disabled: _ctx.isDisabledAddForm,
          onClick: _ctx.addFormAreaContainer
        }, null, 8, ["iconLeft", "iconColor", "disabled", "onClick"])
      ])
    ]),
    (_ctx.areaForms.length)
      ? (_openBlock(), _createBlock("div", {
          key: 0,
          class: "h-full",
          style: { maxHeight: 'calc(100vh - 60px)', overflowY: 'auto' }
        }, [
          (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.areaForms, (form, index) => {
            return (_openBlock(), _createBlock("div", {
              key: form.formId,
              class: "area-card flex flex-col gap-6"
            }, [
              _createVNode("div", _hoisted_8, [
                _createVNode("div", _hoisted_9, [
                  _createVNode("div", _hoisted_10, [
                    _createVNode("div", _hoisted_11, [
                      _createVNode(_component_AreaNameInput, {
                        modelValue: form.areaName,
                        "onUpdate:modelValue": ($event: any) => (form.areaName = $event),
                        formId: form.formId,
                        existingAreaNames: _ctx.areaForms,
                        onValidation: (isValid) => (form.isValid = isValid)
                      }, null, 8, ["modelValue", "onUpdate:modelValue", "formId", "existingAreaNames", "onValidation"])
                    ]),
                    _createVNode("div", _hoisted_12, [
                      _createVNode(_component_GeoAddressTreeSelector, {
                        class: "w-full",
                        options: _ctx.availableGeoAddress,
                        shipmentType: _ctx.getShipmentType(form.selectedVillages),
                        excludeGeoAddressIds: _ctx.selectedGeoAddressIds,
                        modelValue: form.selectedVillages,
                        "onUpdate:modelValue": ($event: any) => (form.selectedVillages = $event)
                      }, null, 8, ["options", "shipmentType", "excludeGeoAddressIds", "modelValue", "onUpdate:modelValue"])
                    ]),
                    _createVNode("div", _hoisted_13, [
                      _createVNode(_component_AssignCourier, {
                        isShiftEnabled: form.isShiftMode,
                        "onUpdate:isShiftEnabled": ($event: any) => (form.isShiftMode = $event),
                        selectedCourier: form.selectedCourier,
                        "onUpdate:selectedCourier": ($event: any) => (form.selectedCourier = $event)
                      }, null, 8, ["isShiftEnabled", "onUpdate:isShiftEnabled", "selectedCourier", "onUpdate:selectedCourier"])
                    ])
                  ]),
                  _createVNode("div", _hoisted_14, [
                    (index >= 1)
                      ? (_openBlock(), _createBlock("button", {
                          key: 0,
                          class: "w-8 h-8 flex items-center justify-center text-gray-400 hover:bg-red-50 rounded-full",
                          onClick: ($event: any) => (_ctx.confirmationDeleteArea(form.formId))
                        }, [
                          _hoisted_15
                        ], 8, ["onClick"]))
                      : _createCommentVNode("", true)
                  ])
                ])
              ]),
              _createVNode(_component_DynamicShift, {
                isShiftEnabled: form.isShiftMode,
                onShiftsChange: (val) => form.shifts = val,
                shifts: form.shifts,
                "onUpdate:shifts": ($event: any) => (form.shifts = $event)
              }, null, 8, ["isShiftEnabled", "onShiftsChange", "shifts", "onUpdate:shifts"])
            ]))
          }), 128))
        ], 4))
      : _createCommentVNode("", true)
  ]))
})